import { render, staticRenderFns } from "./NoticeWrite.vue?vue&type=template&id=73266af4&scoped=true"
import script from "./NoticeWrite.vue?vue&type=script&lang=js"
export * from "./NoticeWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73266af4",
  null
  
)

export default component.exports